
export const Logout = (navigate)=>{
    localStorage.clear()
    navigate('/loginscreen')
}

export const capitalizeFirst = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export default {Logout,capitalizeFirst}